import { GridStyled } from 'components/GridFields/GridFields.styles';
import { styled } from 'libs/ui/styled';

export const GridFieldsStyled = styled(GridStyled)(() => ({
  '.order-submission-contact-value-field': {
    marginTop: 'auto',
  },
}));
